export enum ServicesEnums {
    ROYALE = "ROYALE",
    PARTY = "PARTY",
    SUBSCRIPTION = "SUBSCRIPTION",
    CHEFIT = "CHEFIT",
    BOOK_BY_DISH = "BOOK_BY_DISH",
}
